import { render, staticRenderFns } from "./CrewChangeTaskList.vue?vue&type=template&id=90225b50&scoped=true"
import script from "./CrewChangeTaskList.vue?vue&type=script&lang=js"
export * from "./CrewChangeTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90225b50",
  null
  
)

export default component.exports